import * as THREE from 'three';
import SVGLoader2 from './SVGLoader2'

import { incRenderCount } from './initThree';

export class PaintingMaker {
    layers = [];
    thicknessEach = 1.5;
    allInOne = new THREE.Group();

    constructor(scene) {
        this.allInOne.rotation.x = Math.PI;
        this.allInOne.position.x = -76;
        this.allInOne.position.y = 57;
        scene.add(this.allInOne);
        this.scene = scene;
    }

    alterLayer(i, layerUrl, color) {
        var loader = new SVGLoader2();
        let t = this.thicknessEach;
        let allInOne = this.allInOne;
        let layers = this.layers;
        if (layers[i]) {
            // layers[i].traverse(function (mesh) {
            //     console.log(mesh);
            //     // mesh.geometry.dispose();
            // });
            allInOne.remove(layers[i]);
            layers[i] = null;
        }
        loader.load(
            layerUrl,
            function (data) {
                var paths = data.paths;
                var group = new THREE.Group();
                for (let i = 0; i < paths.length; i++) {
                    var path = paths[i];
                    var material = new THREE.MeshPhongMaterial({ color: color === undefined ? 0xffffff : color });
                    var shapes = path.toShapes(false);
                    for (var j = 0; j < shapes.length; j++) {
                        var shape = shapes[j];
                        var geometry = new THREE.ExtrudeBufferGeometry(shape, {
                            depth: t,
                            bevelEnabled: false,
                            curveSegments: 36,
                        });
                        var mesh = new THREE.Mesh(geometry, material);
                        group.add(mesh);
                    }
                }
                group.position.z = t * i;
                layers[i] = group;
                allInOne.add(group);
                incRenderCount();
            },
            function (xhr) {
                console.log((xhr.loaded / xhr.total * 100) + '% loaded');
            },
            function (error) {
                console.log('An error happened');
                console.error(error);
            }
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/decorativePainting/scripts/PaintingMaker.js